// extracted by mini-css-extract-plugin
export default {"filters":"Filters_filters__hUDju","group":"Filters_group__aKYGn","filteredFeaturesLength":"Filters_filteredFeaturesLength__d0mqU","totalDevDays":"Filters_totalDevDays__63UF8"};